import type {
  AttackCategory,
  Sector,
  ThreatActor,
} from "@/types/risk-analysis";

// NIS2 Sectors (Annex I - High Criticality & Annex II - Other Critical Sectors)
export const SECTOARE_NIS2: Sector[] = [
  // Annex I - Sectoare de criticalitate înaltă
  {
    id: "I.1",
    cod: "energy",
    nume: "Energie",
    subsectoare: "Electricitate, Heating & cooling, Oil, Gas, Hydrogen",
    annex: "I",
  },
  {
    id: "I.2",
    cod: "transport",
    nume: "Transport",
    subsectoare: "Aerian, Feroviar, Naval, Rutier",
    annex: "I",
  },
  {
    id: "I.4",
    cod: "financial",
    nume: "Infrastructură Piață Financiară",
    subsectoare: "Instituții de credit, platforme de tranzacționare",
    annex: "I",
  },
  {
    id: "I.5",
    cod: "health",
    nume: "Sănătate",
    subsectoare:
      "Furnizori servicii medicale, laboratoare, producători medicamente",
    annex: "I",
  },
  {
    id: "I.6",
    cod: "drinking-water",
    nume: "Apă Potabilă",
    subsectoare: "Furnizori și distribuitori apă",
    annex: "I",
  },
  {
    id: "I.7",
    cod: "waste-water",
    nume: "Apă Uzată",
    subsectoare: "Întreprinderi colectare și tratare ape uzate",
    annex: "I",
  },
  {
    id: "I.8",
    cod: "digital-infra",
    nume: "Infrastructură Digitală",
    subsectoare: "DNS, TLD, ISP, Cloud, Data Centers, CDN",
    annex: "I",
  },
  {
    id: "I.10",
    cod: "public-admin",
    nume: "Administrație Publică",
    subsectoare: "Entități guvernamentale centrale și regionale",
    annex: "I",
  },
  {
    id: "I.11",
    cod: "space",
    nume: "Spațiu",
    subsectoare: "Operatori infrastructură sol",
    annex: "I",
  },

  // Annex II - Alte sectoare critice
  {
    id: "II.1",
    cod: "postal",
    nume: "Servicii Poștale și Curierat",
    subsectoare: "Furnizori servicii poștale",
    annex: "II",
  },
  {
    id: "II.2",
    cod: "waste-mgmt",
    nume: "Gestionarea deșeurilor",
    subsectoare: "Întreprinderi gestionare deșeuri",
    annex: "II",
  },
  {
    id: "II.3",
    cod: "chemicals",
    nume: "Producție și Distribuție Chimicale",
    subsectoare: "Fabricare, producție, distribuție",
    annex: "II",
  },
  {
    id: "II.4",
    cod: "food",
    nume: "Producția, prelucrarea și/sau distribuția de alimente",
    subsectoare: "Producție, procesare, distribuție",
    annex: "II",
  },
  {
    id: "II.5",
    cod: "manufacturing",
    nume: "Producție",
    subsectoare: "Dispozitive medicale, echipamente electronice, auto",
    annex: "II",
  },
  {
    id: "II.6",
    cod: "digital-providers",
    nume: "Furnizori Digitali",
    subsectoare: "Marketplace online, motoare căutare, social media",
    annex: "II",
  },
  {
    id: "II.7",
    cod: "research",
    nume: "Cercetare",
    subsectoare: "Organizații de cercetare",
    annex: "II",
  },
];

// Threat Actors (5 actors: 3 Common Skills + 2 Extended Skills)
export const ACTORI_AMENINTARE: ThreatActor[] = [
  {
    id: "competitori",
    nume: "Competitori ostili",
    categorie: "Common skills",
    descriere: "Actori cu abilități comune",
  },
  {
    id: "activisti",
    nume: "Activiști motivați ideologic",
    categorie: "Common skills",
    descriere: "Actori cu abilități comune",
  },
  {
    id: "teroristi",
    nume: "Teroriști",
    categorie: "Common skills",
    descriere: "Actori cu abilități comune",
  },
  {
    id: "infractori",
    nume: "Infractori cibernetici",
    categorie: "Extended Skills",
    descriere: "Actori cu abilități avansate",
  },
  {
    id: "actori",
    nume: "Actori statali",
    categorie: "Extended Skills",
    descriere: "Actori statali cu resurse și capabilități avansate",
  },
];

// Attack Categories (5 categories with default impact and attack type)
export const CATEGORII_ATACURI: AttackCategory[] = [
  {
    id: "sabotage",
    nume: "Sabotaj / Întrerupere",
    descriere: "DDOS, întreruperi de serviciu",
    tipAtac: "targeted",
    impactDefault: "Ridicat",
  },
  {
    id: "theft",
    nume: "Furt de Informații",
    descriere: "Spionaj, exfiltrare date",
    tipAtac: "targeted",
    impactDefault: "Ridicat",
  },
  {
    id: "crime",
    nume: "Criminalitate",
    descriere: "Atacuri ransomware",
    tipAtac: "global",
    impactDefault: "Ridicat",
  },
  {
    id: "hactivism",
    nume: "Hacktivism",
    descriere: "Subversiune, defacement",
    tipAtac: "global",
    impactDefault: "Mediu",
  },
  {
    id: "disinformation",
    nume: "Dezinformare",
    descriere: "Influențare politică",
    tipAtac: "global",
    impactDefault: "Scăzut",
  },
];
